import { render, staticRenderFns } from "./handleRenData.vue?vue&type=template&id=68446aa6&scoped=true"
import script from "./handleRenData.vue?vue&type=script&lang=js"
export * from "./handleRenData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68446aa6",
  null
  
)

export default component.exports